import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { hideModal } from '../../actions/modal'
import { syncPartnerRestaurantsDetails, SYNC_PARTNER_RESTAURANT_DETAILS } from '../../actions/syncPartnerRestaurantsDetails'
import ModalComponent from '../../components/modal/index'
import PropTypes from 'prop-types'
import { Button } from 'reactstrap'

export class SyncPartnerRestaurantsDetailsModal extends React.Component {

  constructor() {
    super()
    this.syncPartnerRestaurantsDetails = this.syncPartnerRestaurantsDetails.bind(this)
  }

  syncPartnerRestaurantsDetails() {
    this.props.syncPartnerRestaurantsDetails(this.props.partnerId, this.props.partnerSubscriptionId)
  }

  render() {
    if (this.props.isOpen && this.props.modalType === SYNC_PARTNER_RESTAURANT_DETAILS) {

      const body = <div>Are you sure you want to sync restaurant for partner id <mark>{this.props.partnerId}</mark>?</div>

      const primaryButton = <Button color="danger" onClick={this.syncPartnerRestaurantsDetails}>Sync</Button>

      return <ModalComponent
        isOpen={this.props.isOpen}
        body={body}
        toggle={this.props.hideModal}
        primaryButton={primaryButton} />
    }

    return null
  }
}

const mapStateToProps = state => {
  return {
    isOpen: state.modal.isOpen,
    modalType: state.modal.modalType,
    poolId: state.poolDetails.id,
    partnerSubscriptionId: state.poolDetails.partnerSubscriptionId,
    partnerId: state.poolDetails.partnerId,
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
  hideModal,
  syncPartnerRestaurantsDetails
}, dispatch)

SyncPartnerRestaurantsDetailsModal.propTypes = {
  isOpen: PropTypes.bool,
  modalType: PropTypes.string,
  poolId: PropTypes.string,
  hideModal: PropTypes.func,
  syncPartnerRestaurantsDetails: PropTypes.func,
  partnerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  partnerSubscriptionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

SyncPartnerRestaurantsDetailsModal.defaultProps = {
  partnerId: '',
  partnerSubscriptionId: ''
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SyncPartnerRestaurantsDetailsModal)



// WEBPACK FOOTER //
// ./src/containers/modal/syncPartnerRestaurantsDetails.js